<template>
    <div class="home">
        <div>
            <img src="../assets/img/home-banner.png" alt="banner" class="banner-img">
        </div>
        <div class="flow-path">
            <span class="flow-path-title">混剪流程</span>
            <div class="flow-path-content">
                <div class="flow-path-item">
                    <div>1</div>
                    <span>产品创建</span>
                </div>
                <span class="wire"></span>
                <div class="flow-path-item">
                    <div>2</div>
                    <span>素材准备</span>
                </div>
                <span class="wire"></span>
                <div class="flow-path-item">
                    <div>3</div>
                    <span>添加任务</span>
                </div>
                <span class="wire"></span>
                <div class="flow-path-item">
                    <div>4</div>
                    <span>发布视频</span>
                </div>
            </div>
        </div>
        <div class="function">
            <span class="function-title">常用功能</span>
            <div class="function-content">
                <div class="function-item function-item1">
                    <div @click="to('/product')" class="to">
                        <p>产品管理</p>
                        <span>产品诊断创建</span>
                        <router-link to="" class=" function-btn">
                            去添加
                            <i class="el-icon-arrow-right"></i>
                        </router-link>
                    </div>
                </div>
                <div class="function-item function-item2">
                    <div @click="to('/material/photo')" class="to">
                        <p>素材管理</p>
                        <span>视频素材准备</span>
                        <router-link to="" class="function-btn">
                            去管理
                            <i class="el-icon-arrow-right
                "></i>
                        </router-link>

                    </div>
                </div>
                <div class="function-item function-item3">
                    <div @click="to('/task')" class="to">
                        <p>任务管理</p>
                        <span>我的发布任务</span>
                        <router-link to="" class="function-btn">
                            去查看
                            <i class="el-icon-arrow-right
                "></i>
                        </router-link>

                    </div>
                </div>
                <div class="function-item function-item4">
                    <div @click="to('/video')" class="to">
                        <p>视频管理</p>
                        <span>发布视频查询</span>
                        <router-link to="" class="function-btn">
                            去查看
                            <i class="el-icon-arrow-right
                "></i>
                        </router-link>
                    </div>
                </div>
                <div class="function-item function-item5">
                    <div @click="to('/quick')" class="to">
                        <p>AI视频创作</p>
                        <span>用AI为视频填充文本内容</span>
                        <router-link to="" class="function-btn">
                            去查看
                            <i class="el-icon-arrow-right"></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    name: 'homePage',
    data() {
        return {

        }
    },
    methods: {
        to(url) {
            this.$router.push(url)
        }
    },
 
}

</script>
  
<style scoped>
.home .banner-img {
    width: 100%;
}

.flow-path {
    margin-top: 10px;
}

.flow-path-title {
    width: 105px;
    height: 40px;
    background-color: #2882ff;
    border-radius: 0px 10px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    color: #fff;
    font-weight: bold;
}

.flow-path-content {
    width: 100%;
    height: 80px;
    background-color: #fff;
    border: 1px solid #4895ff;
    border-radius: 0px 3px 3px 3px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.flow-path-item {
    display: flex;
    align-items: center;
}

.flow-path-item div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background-color: #2882ff;
    color: #fff;
    margin-right: 10px;
}

.flow-path-item span {
    font-size: 16px;
    color: #333;
}

.wire {
    display: block;
    width: 89px;
    height: 1px;
    background-color: #d4d4d4;
    margin: 0 15px;
}

.function {
    box-sizing: border-box;
    padding: 20px 50px 60px 20px;
    background-color: #fff;
    margin-top: 10px;
}

.function .function-title {
    font-size: 16px;
    color: #000;
    font-weight: bold;
}

.function .function-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.function-content .function-item {
    width: 48.35%;
    box-sizing: border-box;
    height: 150px;
    padding-top: 36px;
    padding-bottom: 20px;
    margin-top: 28px;
    border-radius: 5px;
}

.function-item div {
    margin-left: 12.27%;
}

.function-item div p {
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    margin: 0;
}

.function-item1 div p {
    text-shadow: 1px 1px 1px rgba(42, 109, 255, 0.31);
}

.function-item2 div p {
    text-shadow: 1px 1px 1px rgba(216, 116, 50, 0.31);
}

.function-item3 div p {
    text-shadow: 1px 1px 1px rgba(42, 109, 255, 0.31);
}

.function-item4 div p {
    text-shadow: 1px 1px 1px rgba(42, 109, 255, 0.31);
}

.function-item5 div p {
    text-shadow: 1px 1px 1px rgba(42, 109, 255, 0.31);
}

.function-item div span {
    font-size: 14px;
    color: #fff;
    display: block;
    margin: 10px 0 12px 0;
}

.function-item1 {
    background-image: url(../assets/img/home-item1.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
}

.function-item2 {
    background-image: url(../assets/img/home-item2.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
}

.function-item3 {
    background-image: url(../assets/img/home-item3.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
}

.function-item4 {
    background-image: url(../assets/img/home-item4.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
}

.function-item5 {
    background-image: url(../assets/img/home-item5.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
}


.function-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 30px;
    background-color: #f0f5ff;
    border-radius: 15px;
    font-size: 14px;
    font-weight: bold;
    opacity: 1;
    transition: all 0.2s linear;
}

.function-btn i {
    margin-top: 2px;
    font-weight: bold;
}

.function-item1 .function-btn {
    color: #0f72cf;
}

.function-item2 .function-btn {
    color: #da7434;
}

.function-item3 .function-btn {
    color: #0e9d7e;
}

.function-item4 .function-btn {
    color: #8059fd;
}

.function-item5 .function-btn {
    color: #0f72cf;
}

.function-btn:hover {
    opacity: 0.9;
}

.to {
    cursor: pointer;
}

.function {
    height: calc(100vh - 450px);
    overflow-y: auto;
}
</style>